module.exports = __webpack_public_path__ + "img/01-T.5e4c5b3c.png";